import React, { useState } from "react";
import {
  Box,
  capitalize,
  Drawer,
  Fade,
  IconButton,
  makeStyles,
  Typography
} from "@material-ui/core";
import CloseIcon from "@material-ui/icons/Close";
import clsx from "clsx";
import { useSnackbar } from "notistack";
import FormModal from "./FormModal";
import AppCard from "./AppCard";
import rentmanLogo from "../../../assets/rentman.svg";
// import shopifyLogo from "../../../assets/shopify.svg";
// import woocommerceLogo from "../../../assets/woocommerce.svg";

import { connect } from "react-redux";
import API from "../../../utils/axios";
import { setApps } from "../../../store/actions/account";
import LoadingCircle from "../../common/LoadingCircle";
import ConfirmDialog from "../../dialogs/ConfirmDialog";

const useStyles = makeStyles(theme => ({
  root: {
    zIndex: "1302 !important"
  },

  paper: {
    maxWidth: "100%"
  },

  contentWrapper: {
    minWidth: 600,
    transition: theme.transitions.create(["padding"], {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.enteringScreen
    }),
    // width: "100%",
    maxWidth: 904
  },
  header: {
    boxSizing: "border-box",
    border: "1px solid #eee"
  },
  title: {
    fontSize: "1.25rem",
    lineHeight: "1.4375rem",
    fontWeight: 500
  },
  iconButton: {
    marginLeft: "-0.5rem",
    marginRight: theme.spacing(2),
    "& svg": {
      width: theme.spacing(3),
      height: theme.spacing(3)
    }
  }
}));

function AppsDialog({ open, drawerOpen, handleClose, apps, setApps }) {
  const classes = useStyles();
  const { enqueueSnackbar } = useSnackbar();
  const [loading, setLoading] = useState(false);
  const [modalState, setModalState] = React.useState({ open: false, app: "" });
  const [confirmDialogState, setConfirmDialogState] = useState({
    open: false,
    id: null
  });

  const handleModalClose = (inputValues, setInputValues) => {
    setModalState({ ...modalState, open: false });
    if (setInputValues) {
      setInputValues(
        Object.keys(inputValues).map(value => (inputValues[value] = ""))
      );
    }
  };

  const disconnectApp = app => {
    setLoading(true);
    API.delete(`/v1/apps/${app.id}`)
      .then(res => {
        setApps(apps.filter(currentApp => currentApp.id !== app.id));
        enqueueSnackbar(`${capitalize(app.name)} disconnected.`);
      })
      .catch(err => {
        console.log(err);
        enqueueSnackbar(`Something went wrong`);
      })
      .finally(() => setLoading(false));
  };

  const handleConnect = (title, app) => {
    if (app) {
      setConfirmDialogState({
        open: true,
        id: app.id,
        title: `Disconnect app?`,
        body: `Routetitan will be disconnected from your ${capitalize(
          app.name
        )} environment.`,
        confirmText: `Disconnect`,
        action: () => {
          disconnectApp(app);
        }
      });
    } else {
      setModalState({ open: true, app: title });
    }
  };

  return (
    <Drawer
      disableEscapeKeyDown
      open={open}
      id={`appsDialog`}
      onClose={handleClose}
      className={classes.root}
      classes={{
        paper: classes.paper
      }}
      anchor="left"
      ModalProps={{
        BackdropProps: { className: classes.backdrop }
      }}
    >
      {/* Loading */}
      <Fade in={loading} mountOnEnter unmountOnExit>
        <LoadingCircle
          style={{ paddingLeft: drawerOpen ? 280 : 56, zIndex: 1600 }}
        />
      </Fade>
      <Box
        className={clsx(classes.contentWrapper)}
        style={{ paddingLeft: drawerOpen ? 280 : 56 }}
      >
        <Box
          className={classes.header}
          display="flex"
          justifyContent="space-between"
          px={3}
          py={2.5}
        >
          <Box alignSelf="center" alignItems="center" display="flex" pr={2}>
            <IconButton
              onClick={() => handleClose()}
              className={classes.iconButton}
            >
              <CloseIcon />
            </IconButton>
            <Typography className={classes.title} variant="h5">
              Apps
            </Typography>
          </Box>
        </Box>
        <Box p={3}>
          <AppCard
            appLogo={rentmanLogo}
            title={"Rentman"}
            app={apps.find(app => app.name === "rentman" && app.is_available)}
            handleConnect={handleConnect}
            description={
              "Cloud rental software for AV & Event companies. Experience the all-in-one rental software to run a more efficient business. Resource planning, scheduling, and communication all seamlessly integrated in an easy-to-use system."
            }
          />
          {/* TODO: moved to 1.10 */}
          {/* <AppCard
            appLogo={shopifyLogo}
            title={"Shopify"}
            app={apps.find(app => app.name === "shopify" && app.is_available)}
            handleConnect={handleConnect}
            description={`Create new Linear issues from Sentry exceptions and link Sentry exceptions to existing Linear issues. Once enabled, the option will show up in Sentry under "Stops" . When a Linear issue is completed, any linked Sentry issues will be automatically resolved. Re-assigning an issue in Linear will update the assignee on linked Sentry issues, too.`}
          />
          <AppCard
            appLogo={woocommerceLogo}
            title={"WooCommerce"}
            app={apps.find(
              app => app.name === "woocommerce" && app.is_available
            )}
            handleConnect={handleConnect}
            description={`Create new Linear issues from Sentry exceptions and link Sentry exceptions to existing Linear issues. Once enabled, the option will show up in Sentry under "Stops" . When a Linear issue is completed, any linked Sentry issues will be automatically resolved. Re-assigning an issue in Linear will update the assignee on linked Sentry issues, too.`}
          /> */}
        </Box>
      </Box>
      <FormModal
        handleClose={handleModalClose}
        setLoading={setLoading}
        open={modalState.open}
        app={modalState.app}
        apps={apps}
        setApps={setApps}
      />
      <ConfirmDialog
        open={confirmDialogState.open}
        handleClose={() =>
          setConfirmDialogState({ ...confirmDialogState, open: false })
        }
        action={confirmDialogState.action}
        title={confirmDialogState.title}
        body={confirmDialogState.body}
        confirmText={confirmDialogState.confirmText}
      />
    </Drawer>
  );
}

const mapStateToProps = state => ({
  drawerOpen: state.account.accountDrawerOpen,
  apps: state.account.apps
});

export default connect(mapStateToProps, {
  setApps
})(AppsDialog);
